export const mapValues = <
  TRecord extends Record<string, unknown>,
  TKey extends keyof TRecord,
  TMappedValue,
>(
  record: TRecord,
  callback: (value: TRecord[TKey], key: TKey, input: TRecord) => TMappedValue,
) =>
  Object.fromEntries(
    Object.entries(record).map(([key, value]) => [
      key,
      callback(value as TRecord[TKey], key as TKey, record),
    ]),
  ) as Record<TKey, TMappedValue>;
